import $api from "@/zapi-frontend/shared/api/axios";
import { TUser, TUserRole, TAccessMode } from "./schemas";

export async function updateUser({
  orgId,
  userId,
  role,
  accessMode,
  active
}: {
  orgId: number;
  userId: number;
  role: TUserRole;
  accessMode?: TAccessMode;
  active: boolean;
}) {
  const response = await $api.patch<TUser>(`/organizations/${orgId}/users/${userId}`, {
    role,
    accessMode,
    active
  });
  //   const parsed = UserSchema.parse(response.data);
  //   return parsed;
  return response.data;
}
